import { React, useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  RightLayoutContainer,
  PageTitleComp,
  DetailFields,
  DownArrowDraw,
  DropDownSearchDraw,
} from "../../styledElements";
import Iconmoon from "../../../Components/IconsFiles/icon";
import ReactPaginate from "react-paginate";
import {
  Styled,
  DatePickerY,
  GlobalSet,
  DisabledButtonStyle,
} from "../../pageStyled";
import { DatePicker } from "antd";
import {
  Button,
  Row,
  Col,
  Form,
  Input,
  Select,
  PageHeader,
  Checkbox,
  Tooltip,
} from "antd";
import { HaberForm } from "../../styledElements";
import { useWindowDimensions } from "../../../hooks/useWindowDimensions";
import { addNewCustomer, getCustomers } from "../../../Services/customerServices";
import moment from "moment";
import CountryPhoneInput, { ConfigProvider } from "antd-country-phone-input";
import en from "world_countries_lists/data/countries/en/world.json";
import "antd-country-phone-input/dist/index.css";
import "flagpack/dist/flagpack.css";
import { Country, State } from "country-state-city";
import { capital_letter, toHandlePOName } from "../../../Utils/helper/helper";
import FormItem from "antd/lib/form/FormItem";
import ConfirmationModal from "../../../Components/Modal/ConfirmationModal";
import { ModalPopup } from "../../../Components/Modal/modal";
import warning from "../../../Assets/Icons/warning.png";
import {
  getMachineGradeSelect,
  getReelCoreValues,
} from "../../../Services/settingsServices";
import { getUnitData } from "../../../Services/measurementService";
import { saveUploadedOrders } from "../../../Services/orderServices";
import { getProductsData } from "../../../Services/productServices";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import emptyState_NoData from "../../../Assets/Images/emptyState_NoData.svg";
import EmptyState from "../../../Components/EmptyState/emptyState";
import {
  calculatePlannedReels,
  calculatePlannedWeight,
  plannedReelsCalculations
} from "../../../Utils/helper/calculatePlannedWeight";
import TableShimmer from "../../../../src/Components/TableShimmer/tableShimmer";
import {
  lengthUnit,
  weightUnit,
  weight_Unit_Conversions,
  orderDim_Rewinder_Unit_Conversion,
  currency_List,
  conversionFactorTonneToUnits,
} from "../../../Utils/Constant/MeasurementUnitList";
import SoValidation from "./soValidation";
import { getWorkflowSettings } from "../../../Services/workFlowSettingsServices";
import AddNewCustomerDrawer from "../ConflictingOrders/AddNewCustomerDrawer";
const capitalize = (item) => item?.charAt(0)?.toUpperCase() + item?.slice(1);
const { TextArea } = Input;

const UploadSummary = (props) => {
  const history = useNavigate();
  const location = useLocation();
  const { height, width } = useWindowDimensions();
  const [form] = Form.useForm();
  const [customerList, setCustomerList] = useState([]);
  const [isCustomerDropdownOpen, setCustomerDropdown] = useState(false);
  const [selectedPOs, setSelectedPOs] = useState(location?.state?.action);
  const poData = useRef(JSON.parse(JSON.stringify(location?.state?.action)));
  const [customer, setCustomer] = useState("");
  const [rerendering, setRerendering] = useState(false);
  const { Option } = Select;
  const [poIndex, setPoIndex] = useState();
  const [show, setShow] = useState(false);
  const [otherButtonLoading, setOtherButtonLoadingLoadings] = useState(false);
  const [loadings, setLoadings] = useState(false);
  const [resendAppLoading, setResendApprovalLoading] = useState(false);
  const [resendAppOtherButtonLoading, setResendAppOtherButtonLoading] =
    useState(false);
  const [poDataToSave, setPoDataToSave] = useState();
  const [products, setProducts] = useState([]);
  const [measurementData, setMeasurementData] = useState();
  const [savedState, setSavedState] = useState(false);
  const [upperTolerance, setUpperTol] = useState("");
  const [lowerTolerance, setLowerTol] = useState("");
  const [visibleToaster, setVisibleToaster] = useState(false);
  const [emptyStateLabel, setEmptyStateLabel] = useState();
  const [emptyStatePropsData, setEmptyStatePropsData] = useState();
  const [disabledFilterButton, setDisabledButton] = useState(false);
  const [saveDataModal, setSaveDataModal] = useState({
    visible: false,
    data: {},
    type: "",
  });
  const [actionToaster, setActionToaster] = useState({
    error: "",
    msg: "",
  });
  const scrollRef = useRef(null);
  const [currentPage, setCurrentPage] = useState();
  const [shimmerState, setShimmerState] = useState(false);
  const itemsPerPage = 10; // Number of items per page
  const [customerDrawerVisible,setCustomerDrawerVisible] = useState(false);
  const [consigneeDrawerVisible,setConsigneeDrawerVisible] = useState(false);
  const [selectedPo,setSelectedPo] = useState(null);
  const [orderManagementSettings, setOrderManagementSettings] = useState();
  

  const columnsHead = useRef([
    {
      title: "S.No:.",
      dataIndex: "S.no",
      width: "1%",
      align: "left",
    },
    {
      title: "PO/SO Number:",
      dataIndex: "Po.no",
      width: "2%",
      align: "left",
    },
    {
      title: "PO/SO Date:",
      dataIndex: "Podate",
      width: "2%",
      align: "left",
    },
    {
      title: "Customer:",
      dataIndex: "Podate",
      width: "4%",
      align: "left",
    },
    {
      title: "Consingee:",
      dataIndex: "Podate",
      width: "4%",
      align: "left",
    },
    {
      title: "Order Summary:",
      dataIndex: "Podate",
      width: "2%",
      align: "left",
    },
    {
      title: "Action:",
      dataIndex: "Podate",
      width: "2%",
      align: "left",
    },
  ]);

  const addNewCustomer = (po) => {
    setSelectedPo(po);
    setCustomerDrawerVisible(true);
  }

  const addNewConsignee = (po) => {
    setSelectedPo(po);
    setConsigneeDrawerVisible(true);
  }

  const onCloseCustomerDrawer = () => {
    setCustomerDrawerVisible(false);
  }

  const onCloseConsigneeDrawer = () => {
    setConsigneeDrawerVisible(false);
  }

  const onCustomerSave = (response) => {
    console.log(response);
    const updatedCustomer = response?.data?.name;
    const updatedPoData = poData?.current?.data?.pos?.map((po)=>{
      const poCustomer = po?.errors?.customer?.slice(po?.errors?.customer?.indexOf("'")+1,po?.errors?.customer?.lastIndexOf("'"));
      const poConsignee = po?.errors?.consignee?.slice(po?.errors?.consignee?.indexOf("'")+1,po?.errors?.consignee?.lastIndexOf("'"));
      console.log(poConsignee,poCustomer);
      if(poCustomer == updatedCustomer && poConsignee == updatedCustomer)
      {
        delete po?.errors?.consignee;
        delete po?.errors?.customer;
        return {
          error_count: po?.error_count-2,
          errors: {
            ...po?.errors,
          },
          po:{
            ...po?.po,
            consignee: response?.data?.code +" - "+ response?.data?.name,
            customer: response?.data?.code +" - "+ response?.data?.name,
          },
          orders:structuredClone(po?.orders),
        }
      }
      else if(poCustomer == updatedCustomer)
      {
        delete po?.errors?.customer;
        return {
          error_count: po?.error_count-1,
          errors: {
            ...po?.errors,
          },
          po:{
            ...po?.po,
            customer: response?.data?.code +" - "+ response?.data?.name,
          },
          orders:structuredClone(po?.orders),
        }
      }
      else if(poConsignee == updatedCustomer)
      {
        delete po?.errors?.consignee;
        return {
          error_count: po?.error_count-1,
          errors: {
            ...po?.errors,
          },
          po:{
            ...po?.po,
            consignee: response?.data?.code +" - "+ response?.data?.name,
          },
          orders:structuredClone(po?.orders),
        }
      }
      else{
        return structuredClone(po);
      }
    })
    console.log(updatedPoData);
    setSelectedPOs(prev=>({
      msg:prev?.msg,
      data:{
        pos:updatedPoData,
      },
      error:false,
    }))
    poData.current = {
      msg:poData?.current?.msg,
      data:{
        pos:updatedPoData,
      },
      error:false,
    }
    console.log(selectedPOs,poData)
    setCustomerDrawerVisible(false);
    setConsigneeDrawerVisible(false);
    setRerendering(true);
  }

  const OntoggleSelect = () => {
    setCustomerDropdown((prevState) => !prevState);
  };

  const customerHandler = (index, input) => {
    let pos = selectedPOs;
    let originalPOData = JSON.parse(JSON.stringify(poData.current));
    let selectedIndex = originalPOData.data.pos.findIndex(
      (item) => item.po.number == input.po.number
    );
    originalPOData.data.pos[selectedIndex].po.customer = form.getFieldValue(
      `customer${index}`
    );
    pos.data.pos[index].po.customer = form.getFieldValue(`customer${index}`);
    if (pos.data.pos[index].errors.customer) {
      pos.data.pos[index].error_count = pos.data.pos[index].error_count - 1;
      originalPOData.data.pos[selectedIndex].error_count =
        originalPOData.data.pos[selectedIndex].error_count - 1;
      delete originalPOData.data.pos[selectedIndex].errors["customer"];
      delete pos.data.pos[index].errors["customer"];
    }
    poData.current = JSON.parse(JSON.stringify(originalPOData));
    setSelectedPOs(pos);
    setCustomer(form.getFieldValue(`customer${index}`));
    setCustomerAddress(index, input);
    setRerendering(true);
  };

  const setCustomerAddress = (index, input) => {
    const fields = form.getFieldsValue();
    const currentCustomerDetails = customerList.filter((cust) => {
      return cust.code === form.getFieldValue(`customer${index}`);
    });
    let newObj = fields;
    let pos = selectedPOs;
    let originalPOData = JSON.parse(JSON.stringify(poData.current));
    let selectedIndex = originalPOData.data.pos.findIndex(
      (item) => item.po.number == input.po.number
    );
    if (pos.data.pos[index].po.deliverToCustomer) {
      newObj = {
        ...newObj,
        [`delivery_address_line_1${index}`]:
          currentCustomerDetails[0].delivery_address_line_1,
        [`delivery_address_line_2${index}`]:
          currentCustomerDetails[0].delivery_address_line_2,
        [`delivery_country${index}`]: currentCustomerDetails[0].country,
        [`delivery_state${index}`]: currentCustomerDetails[0].state,
        [`delivery_city${index}`]: currentCustomerDetails[0].city,
        [`delivery_pincode${index}`]: currentCustomerDetails[0].pincode,
      };
      //form.setFieldsValue(newObj);
      // let pos = selectedPOs;
      pos.data.pos[index].po.delivery_address_line_1 =
        currentCustomerDetails[0].delivery_address_line_1;
      pos.data.pos[index].po.delivery_address_line_2 =
        currentCustomerDetails[0].delivery_address_line_2;
      pos.data.pos[index].po.delivery_state = currentCustomerDetails[0].state;
      pos.data.pos[index].po.delivery_city = currentCustomerDetails[0].city;
      pos.data.pos[index].po.delivery_pincode =
        currentCustomerDetails[0].pincode;
      pos.data.pos[index].po.delivery_country =
        currentCustomerDetails[0].country;

      originalPOData.data.pos[selectedIndex].po.delivery_address_line_1 =
        currentCustomerDetails[0].delivery_address_line_1;
      originalPOData.data.pos[selectedIndex].po.delivery_address_line_2 =
        currentCustomerDetails[0].delivery_address_line_2;
      originalPOData.data.pos[selectedIndex].po.delivery_state =
        currentCustomerDetails[0].state;
      originalPOData.data.pos[selectedIndex].po.delivery_city =
        currentCustomerDetails[0].city;
      originalPOData.data.pos[selectedIndex].po.delivery_pincode =
        currentCustomerDetails[0].pincode;
      originalPOData.data.pos[selectedIndex].po.delivery_country =
        currentCustomerDetails[0].country;

      //setSelectedPOs(pos);
    }
    if (pos.data.pos[index].po.shipToCustomer) {
      newObj = {
        ...newObj,
        [`shipping_address_line_1${index}`]:
          currentCustomerDetails[0].delivery_address_line_1,
        [`shipping_address_line_2${index}`]:
          currentCustomerDetails[0].delivery_address_line_2,
        [`shipping_country${index}`]: currentCustomerDetails[0].country,
        [`shipping_state${index}`]: currentCustomerDetails[0].state,
        [`shipping_city${index}`]: currentCustomerDetails[0].city,
        [`shipping_pincode${index}`]: currentCustomerDetails[0].pincode,
      };
      //form.setFieldsValue(newObj);
      pos.data.pos[index].po.shipping_address_line_1 =
        currentCustomerDetails[0].delivery_address_line_1;
      pos.data.pos[index].po.shipping_address_line_2 =
        currentCustomerDetails[0].delivery_address_line_2;
      pos.data.pos[index].po.shipping_state = currentCustomerDetails[0].state;
      pos.data.pos[index].po.shipping_city = currentCustomerDetails[0].city;
      pos.data.pos[index].po.shipping_pincode =
        currentCustomerDetails[0].pincode;
      pos.data.pos[index].po.shipping_country =
        currentCustomerDetails[0].country;
      //setSelectedPOs(pos);

      originalPOData.data.pos[selectedIndex].po.shipping_address_line_1 =
        currentCustomerDetails[0].delivery_address_line_1;
      originalPOData.data.pos[selectedIndex].po.shipping_address_line_2 =
        currentCustomerDetails[0].delivery_address_line_2;
      originalPOData.data.pos[selectedIndex].po.shipping_state =
        currentCustomerDetails[0].state;
      originalPOData.data.pos[selectedIndex].po.shipping_city =
        currentCustomerDetails[0].city;
      originalPOData.data.pos[selectedIndex].po.shipping_pincode =
        currentCustomerDetails[0].pincode;
      originalPOData.data.pos[selectedIndex].po.shipping_country =
        currentCustomerDetails[0].country;
    }
    if (pos.data.pos[index].po.billToCustomer) {
      newObj = {
        ...newObj,
        [`billing_address_line_1${index}`]:
          currentCustomerDetails[0].delivery_address_line_1,
        [`billing_address_line_2${index}`]:
          currentCustomerDetails[0].delivery_address_line_2,
        [`billing_country${index}`]: currentCustomerDetails[0].country,
        [`billing_state${index}`]: currentCustomerDetails[0].state,
        [`billing_city${index}`]: currentCustomerDetails[0].city,
        [`billing_pincode${index}`]: currentCustomerDetails[0].pincode,
      };
      //form.setFieldsValue(newObj);
      // let pos = selectedPOs;
      pos.data.pos[index].po.billing_address_line_1 =
        currentCustomerDetails[0].delivery_address_line_1;
      pos.data.pos[index].po.billing_address_line_2 =
        currentCustomerDetails[0].delivery_address_line_2;
      pos.data.pos[index].po.billing_state = currentCustomerDetails[0].state;
      pos.data.pos[index].po.billing_city = currentCustomerDetails[0].city;
      pos.data.pos[index].po.billing_pincode =
        currentCustomerDetails[0].pincode;
      pos.data.pos[index].po.billing_country =
        currentCustomerDetails[0].country;

      originalPOData.data.pos[selectedIndex].po.billing_address_line_1 =
        currentCustomerDetails[0].delivery_address_line_1;
      originalPOData.data.pos[selectedIndex].po.billing_address_line_2 =
        currentCustomerDetails[0].delivery_address_line_2;
      originalPOData.data.pos[selectedIndex].po.billing_state =
        currentCustomerDetails[0].state;
      originalPOData.data.pos[selectedIndex].po.billing_city =
        currentCustomerDetails[0].city;
      originalPOData.data.pos[selectedIndex].po.billing_pincode =
        currentCustomerDetails[0].pincode;
      originalPOData.data.pos[selectedIndex].po.billing_country =
        currentCustomerDetails[0].country;
    }
    poData.current = JSON.parse(JSON.stringify(originalPOData));
    setSelectedPOs(pos);
    form.setFieldsValue(newObj);
  };

  const consigneeHandler = (index, input) => {
    let pos = selectedPOs;
    let originalPOData = JSON.parse(JSON.stringify(poData.current));
    let selectedIndex = originalPOData.data.pos.findIndex(
      (item) => item.po.number == input.po.number
    );
    originalPOData.data.pos[selectedIndex].po.consignee = form.getFieldValue(
      `consignee${index}`
    );
    pos.data.pos[index].po.consignee = form.getFieldValue(`consignee${index}`);
    if (pos.data.pos[index].errors.consignee) {
      delete pos.data.pos[index].errors["consignee"];
      pos.data.pos[index].error_count = pos.data.pos[index].error_count - 1;
      delete originalPOData.data.pos[selectedIndex].errors["consignee"];
      originalPOData.data.pos[selectedIndex].error_count =
        originalPOData.data.pos[selectedIndex].error_count - 1;
    }
    poData.current = JSON.parse(JSON.stringify(originalPOData));
    setSelectedPOs(pos);
    setCustomer(form.getFieldValue(`consignee${index}`));
    setConsigneeAddress(index, input);
    setRerendering(true);
  };

  const setAddress = (event, index, key, input) => {
    let pos = selectedPOs;
    let originalPOData = JSON.parse(JSON.stringify(poData.current));
    let selectedIndex = originalPOData.data.pos.findIndex(
      (item) => item.po.number == input.po.number
    );
    if (key === "delivery_country") {
      pos.data.pos[index].po[key] = Country.getCountryByCode(event).name;
      pos.data.pos[index].po.delivery_states = State.getStatesOfCountry(event);
      originalPOData.data.pos[selectedIndex].po[key] =
        Country.getCountryByCode(event).name;
      originalPOData.data.pos[selectedIndex].po.delivery_states =
        State.getStatesOfCountry(event);
      form.setFieldsValue({ [`delivery_state${index}`]: "" });
    } else if (key === "shipping_country") {
      pos.data.pos[index].po[key] = Country.getCountryByCode(event).name;
      pos.data.pos[index].po.shipping_states = State.getStatesOfCountry(event);
      originalPOData.data.pos[selectedIndex].po[key] =
        Country.getCountryByCode(event).name;
      originalPOData.data.pos[selectedIndex].po.shipping_states =
        State.getStatesOfCountry(event);
      form.setFieldsValue({ [`shipping_state${index}`]: "" });
    } else if (key === "billing_country") {
      pos.data.pos[index].po[key] = Country.getCountryByCode(event).name;
      pos.data.pos[index].po.billing_states = State.getStatesOfCountry(event);
      originalPOData.data.pos[selectedIndex].po[key] =
        Country.getCountryByCode(event).name;
      originalPOData.data.pos[selectedIndex].po.billing_states =
        State.getStatesOfCountry(event);
      form.setFieldsValue({ [`billing_state${index}`]: "" });
    } else {
      pos.data.pos[index].po[key] = event;
      originalPOData.data.pos[selectedIndex].po[key] = event;
    }
    poData.current = JSON.parse(JSON.stringify(originalPOData));
    setSelectedPOs(pos);
    setRerendering(true);
  };

  const setConsigneeAddress = (index, input) => {
    const fields = form.getFieldsValue();
    const currentCustomerDetails = customerList.filter((cust) => {
      return form.getFieldValue(`consignee${index}`).includes(cust.code);
    });
    let newObj = fields;
    let pos = selectedPOs;
    let originalPOData = JSON.parse(JSON.stringify(poData.current));
    let selectedIndex = originalPOData.data.pos.findIndex(
      (item) => item.po.number == input.po.number
    );

    if (pos.data.pos[index].po.deliverToConsignee) {
      newObj = {
        ...newObj,
        [`delivery_address_line_1${index}`]:
          currentCustomerDetails[0].delivery_address_line_1,
        [`delivery_address_line_2${index}`]:
          currentCustomerDetails[0].delivery_address_line_2,
        [`delivery_country${index}`]: currentCustomerDetails[0].country,
        [`delivery_state${index}`]: currentCustomerDetails[0].state,
        [`delivery_city${index}`]: currentCustomerDetails[0].city,
        [`delivery_pincode${index}`]: currentCustomerDetails[0].pincode,
      };

      pos.data.pos[index].po.delivery_address_line_1 =
        currentCustomerDetails[0].delivery_address_line_1;
      pos.data.pos[index].po.delivery_address_line_2 =
        currentCustomerDetails[0].delivery_address_line_2;
      pos.data.pos[index].po.delivery_state = currentCustomerDetails[0].state;
      pos.data.pos[index].po.delivery_city = currentCustomerDetails[0].city;
      pos.data.pos[index].po.delivery_pincode =
        currentCustomerDetails[0].pincode;
      pos.data.pos[index].po.delivery_country =
        currentCustomerDetails[0].country;
      //setSelectedPOs(pos);

      originalPOData.data.pos[selectedIndex].po.delivery_address_line_1 =
        currentCustomerDetails[0].delivery_address_line_1;
      originalPOData.data.pos[selectedIndex].po.delivery_address_line_2 =
        currentCustomerDetails[0].delivery_address_line_2;
      originalPOData.data.pos[selectedIndex].po.delivery_state =
        currentCustomerDetails[0].state;
      originalPOData.data.pos[selectedIndex].po.delivery_city =
        currentCustomerDetails[0].city;
      originalPOData.data.pos[selectedIndex].po.delivery_pincode =
        currentCustomerDetails[0].pincode;
      originalPOData.data.pos[selectedIndex].po.delivery_country =
        currentCustomerDetails[0].country;
    }
    if (pos.data.pos[index].po.shipToConsignee) {
      newObj = {
        ...newObj,
        [`shipping_address_line_1${index}`]:
          currentCustomerDetails[0].delivery_address_line_1,
        [`shipping_address_line_2${index}`]:
          currentCustomerDetails[0].delivery_address_line_2,
        [`shipping_country${index}`]: currentCustomerDetails[0].country,
        [`shipping_state${index}`]: currentCustomerDetails[0].state,
        [`shipping_city${index}`]: currentCustomerDetails[0].city,
        [`shipping_pincode${index}`]: currentCustomerDetails[0].pincode,
      };
      //form.setFieldsValue(newObj);
      //let pos = selectedPOs;
      pos.data.pos[index].po.shipping_address_line_1 =
        currentCustomerDetails[0].delivery_address_line_1;
      pos.data.pos[index].po.shipping_address_line_2 =
        currentCustomerDetails[0].delivery_address_line_2;
      pos.data.pos[index].po.shipping_state = currentCustomerDetails[0].state;
      pos.data.pos[index].po.shipping_city = currentCustomerDetails[0].city;
      pos.data.pos[index].po.shipping_pincode =
        currentCustomerDetails[0].pincode;
      pos.data.pos[index].po.shipping_country =
        currentCustomerDetails[0].country;
      //setSelectedPOs(pos);

      originalPOData.data.pos[selectedIndex].po.shipping_address_line_1 =
        currentCustomerDetails[0].delivery_address_line_1;
      originalPOData.data.pos[selectedIndex].po.shipping_address_line_2 =
        currentCustomerDetails[0].delivery_address_line_2;
      originalPOData.data.pos[selectedIndex].po.shipping_state =
        currentCustomerDetails[0].state;
      originalPOData.data.pos[selectedIndex].po.shipping_city =
        currentCustomerDetails[0].city;
      originalPOData.data.pos[selectedIndex].po.shipping_pincode =
        currentCustomerDetails[0].pincode;
      originalPOData.data.pos[selectedIndex].po.shipping_country =
        currentCustomerDetails[0].country;
    }
    if (pos.data.pos[index].po.billToConsignee) {
      newObj = {
        ...newObj,
        [`billing_address_line_1${index}`]:
          currentCustomerDetails[0].delivery_address_line_1,
        [`billing_address_line_2${index}`]:
          currentCustomerDetails[0].delivery_address_line_2,
        [`billing_country${index}`]: currentCustomerDetails[0].country,
        [`billing_state${index}`]: currentCustomerDetails[0].state,
        [`billing_city${index}`]: currentCustomerDetails[0].city,
        [`billing_pincode${index}`]: currentCustomerDetails[0].pincode,
      };
      //form.setFieldsValue(newObj);
      //let pos = selectedPOs;
      pos.data.pos[index].po.billing_address_line_1 =
        currentCustomerDetails[0].delivery_address_line_1;
      pos.data.pos[index].po.billing_address_line_2 =
        currentCustomerDetails[0].delivery_address_line_2;
      pos.data.pos[index].po.billing_state = currentCustomerDetails[0].state;
      pos.data.pos[index].po.billing_city = currentCustomerDetails[0].city;
      pos.data.pos[index].po.billing_pincode =
        currentCustomerDetails[0].pincode;
      pos.data.pos[index].po.billing_country =
        currentCustomerDetails[0].country;

      originalPOData.data.pos[selectedIndex].po.billing_address_line_1 =
        currentCustomerDetails[0].delivery_address_line_1;
      originalPOData.data.pos[selectedIndex].po.billing_address_line_2 =
        currentCustomerDetails[0].delivery_address_line_2;
      originalPOData.data.pos[selectedIndex].po.billing_state =
        currentCustomerDetails[0].state;
      originalPOData.data.pos[selectedIndex].po.billing_city =
        currentCustomerDetails[0].city;
      originalPOData.data.pos[selectedIndex].po.billing_pincode =
        currentCustomerDetails[0].pincode;
      originalPOData.data.pos[selectedIndex].po.billing_country =
        currentCustomerDetails[0].country;
    }
    poData.current = JSON.parse(JSON.stringify(originalPOData));
    form.setFieldsValue(newObj);
    setSelectedPOs(pos);
  };

  const onPONumberChange = (index, input) => {
    let pos = selectedPOs;
    let originalPOData = JSON.parse(JSON.stringify(poData.current));
    let selectedIndex = originalPOData.data.pos.findIndex(
      (item) => item.po.number == input.po.number
    );
    originalPOData.data.pos[selectedIndex].po.number = form.getFieldValue(
      `poNumber${index}`
    );
    pos.data.pos[index].po.number = form.getFieldValue(`poNumber${index}`);
    if (pos.data.pos[index].errors.number) {
      delete pos.data.pos[index].errors["number"];
      pos.data.pos[index].error_count = pos.data.pos[index].error_count - 1;
      delete originalPOData.data.pos[selectedIndex].errors["number"];
      originalPOData.data.pos[selectedIndex].error_count =
        originalPOData.data.pos[selectedIndex].error_count - 1;
    }
    poData.current = JSON.parse(JSON.stringify(originalPOData));
    setSelectedPOs(pos);
    setRerendering(true);
  };

  const onPoDateChange = (index, input) => {
    let pos = selectedPOs;
    let originalPOData = JSON.parse(JSON.stringify(poData.current));
    let selectedIndex = originalPOData.data.pos.findIndex(
      (item) => item.po.number == input.po.number
    );
    let poDate = form.getFieldValue(`PODate${index}`);
    originalPOData.data.pos[selectedIndex].po.date = moment(
      new Date(poDate._d)
    ).format("YYYY-MM-DD");
    pos.data.pos[index].po.date = moment(new Date(poDate._d)).format(
      "YYYY-MM-DD"
    );
    if (pos.data.pos[index].errors.date) {
      delete pos.data.pos[index].errors["date"];
      pos.data.pos[index].error_count = pos.data.pos[index].error_count - 1;
      delete originalPOData.data.pos[selectedIndex].errors["date"];
      originalPOData.data.pos[selectedIndex].error_count =
        originalPOData.data.pos[selectedIndex].error_count - 1;
    }
    poData.current = JSON.parse(JSON.stringify(originalPOData));
    setSelectedPOs(pos);
    setRerendering(true);
  };

  const redirectToViewOrders = (index, input) => {
    let pos = selectedPOs;
    let originalPOData = JSON.parse(JSON.stringify(poData.current));
    let selectedIndex = originalPOData.data.pos.findIndex(
      (item) => item.po.number == input.po.number
    );
    // for (let index = 0; index < pos.data.pos.length; index++) {
    //   let poData = pos.data.pos[index];
    //   delete poData.po.deliverToConsignee;
    //   delete poData.po.deliverToCustomer;
    //   delete poData.po.shipToConsignee;
    //   delete poData.po.shipToCustomer;
    //   delete poData.po.billToCustomer;
    //   delete poData.po.billToConsignee;
    //   delete poData.po.delivery_countries;
    //   delete poData.po.delivery_states;
    //   delete poData.po.shipping_countries;
    //   delete poData.po.shipping_states;
    //   delete poData.po.billing_countries;
    //   delete poData.po.billing_states;
    //   pos.data.pos[index] = poData;
    // }
    pos.data.pos[index].orders.forEach((item, index1) => {
      item.order["orderNumber"] = index1 + 1;
    });
    originalPOData.data.pos[selectedIndex].orders.forEach((ele, i) => {
      ele.order["orderNumber"] = i + 1;
    });
    poData.current = JSON.parse(JSON.stringify(originalPOData));
    setSelectedPOs(pos);
    setPoIndex(index);
    history("../order-records/uploaded-orders-under-po", {
      state: {
        selectedPoIndex: index,
        uploadedData: pos,
        originalArr: poData.current,
        format: location?.state?.format,
        checkBoxValue: location.state?.checkBoxValue,
        currentPage: currentPage,
        isSOOrders: input.po["po/so"] === "so" ? true : false,
        // filterState: show
      },
    });
  };

  const filterRecords = (filterParam) => {
    setShimmerState(true);
    let allData = JSON.parse(JSON.stringify(poData.current));
    let pos = JSON.parse(JSON.stringify(poData.current));
    let filteredPO = pos.data.pos.filter((item) =>
      filterParam ? item.error_count > 0 || item.po.isErr : item
    );
    pos.data.pos = filteredPO;
    poData.current = JSON.parse(JSON.stringify(allData));
    setSelectedPOs(pos);
    setCurrentPage(1);
    setRerendering(true);
    setTimeout(() => {
      setShimmerState(false);
    }, 2000);
  };

  const saveDataModalClose = (data) => {
    setSaveDataModal({
      ...saveDataModal,
      visible: false,
      type: "" 
    });
  };

  const saveDataModalConfirm = async (data) => {
    setSaveDataModal({
      ...saveDataModal,
      visible: false,
      type: "",
    });

    setLoadings(true);      
    setOtherButtonLoadingLoadings(true);

    let verifiedPOs = data?.current?.data?.pos?.filter(
      (item) => item?.error_count == 0 && !item?.isPOSaved
    );
    let requiredPOData = [];
    let req = {};

    verifiedPOs?.forEach((ele) => {
      if (ele.orders.filter((e) => e.error_count > 0).length == 0) {
        requiredPOData.push(ele);
      }
    });

    req["pos"] = requiredPOData;
    req["mark_orders_complete"] = location.state?.checkBoxValue ? location.state?.checkBoxValue : false;
    req["state"] = saveDataModal.type;
    savePOData(req);
  };

  const savePOData = async (reqData) => {
    // changes without shahpaper and reel od core od new changes
    // let dataToSave = reqData;
    // try {
    //   const response = await getReelCoreValues();
    //   if (!response.error) {
    //     for (let index = 0; index < dataToSave.pos.length; index++) {
    //       if (
    //           dataToSave.pos[index].po["po/so"] === "so" &&
    //           dataToSave.pos[index].po.number
    //         ) {
    //           dataToSave.pos[index].po["reference_number"] =
    //             dataToSave.pos[index].po.number;
    //         }
    //         else{
    //           dataToSave.pos[index].po.number =`${dataToSave.pos[index].po.number}#%#${dataToSave.pos[index].po.customer?.split(" - ")[0] ?? ''}`;
    //           }
    //       for (let ele = 0; ele < dataToSave.pos[index].orders.length; ele++) {
    //         let order = dataToSave.pos[index].orders[ele].order;
    //         console.log('order',order);
            
            
    //         if (dataToSave.pos[index].po["po/so"] === "so") {
    //           order.po = "";
    //           order.delivery_date = null;
              
    //         }
    //         else{
    //           order.po = dataToSave.pos[index].po.number;
    //           // order.delivery_date = dataToSave.pos[index].po.delivery_date;
    //         }
    //         order["category"] = dataToSave.pos[index].po["po/so"];
    //         let productNo = order.product.split(" -");
    //         let productResp = products?.filter(
    //           (ele) => productNo[0] === ele.code
    //         );
    //         let coreIdUnit;
    //         let reelOdUnit;

    //         if (
    //           order.type === "reel" &&
    //           response.default_reel_od &&
    //           response.default_core_id
    //         ) {
    //           if (order.type === "reel") {
    //             let widthData = (
    //               order.width *
    //               orderDim_Rewinder_Unit_Conversion[order.size_unit]
    //             ).toFixed(3);
    //             let diaArr = [];

    //             order.reel_od = response.default_reel_od
    //               ? response.default_reel_od
    //               : 0;
    //             order.core_id = response.default_core_id
    //               ? response.default_core_id
    //               : 0;

    //             if (
    //               (order.outer_dia?.length && order.inner_dia) ||
    //               (order.outer_dia?.length &&
    //                 (order.inner_dia == 0 || order.inner_dia == ""))
    //             ) {
    //               coreIdUnit = response.default_core_unit;
    //               reelOdUnit = response.default_reel_unit;
    //               console.log('reelOdUnit',reelOdUnit,'coreIdUnit',coreIdUnit);


    //             } else if (order.outer_dia?.length == 0 && order.inner_dia) {
    //               coreIdUnit = response.default_core_unit;
    //               reelOdUnit = response.default_core_unit;
    //               console.log('reelOdUnit',reelOdUnit,'coreIdUnit',coreIdUnit);


    //             } else if (
    //               order.outer_dia?.length === 0 &&
    //               (order.inner_dia == 0 || order.inner_dia == "")
    //             ) {

    //              if(response.default_core_unit&&response.default_reel_unit){
    //                 coreIdUnit = response.default_core_unit;
    //                 reelOdUnit = response.default_reel_unit;
    //               console.log('reelOdUnit',reelOdUnit,'coreIdUnit',coreIdUnit);
    //              }
                 
    //              else{
    //               console.log('order',order);
    //               coreIdUnit =
    //                 measurementData.data.units_management.length.default;
    //               reelOdUnit =
    //                 measurementData.data.units_management.length.default;
    //               console.log('reelOdUnit',reelOdUnit,'coreIdUnit',coreIdUnit);
    //              }

    //             }

    //             let outerDiaArr = [];
    //             outerDiaArr.push(response.default_reel_od + " " + reelOdUnit);
    //             order.outer_dia = response.default_reel_od
    //               ? outerDiaArr
    //               : diaArr;
    //             order.inner_dia = response.default_core_id
    //               ? response.default_core_id + " " + coreIdUnit
    //               : "";

    //             if (
    //               order.type === "reel" &&
    //               order.quantity_type === "reel_sheet" &&
    //               order.no_of_reel_sheet
    //             ) {
    //               order.quantity = order.no_of_reel_sheet;
    //               order.weight_unit =
    //                 measurementData.data.units_management.weight.default;
    //               order["planning_quantity"] = order.no_of_reel_sheet;
    //             } else {
    //               let plannedReels = calculatePlannedReels(
    //                 parseFloat(widthData),
    //                 order.weight * weight_Unit_Conversions[order.weight_unit],
    //                 productResp[0].bulk,
    //                 order.outer_dia[0]?.split(" ")[0] *
    //                   orderDim_Rewinder_Unit_Conversion[reelOdUnit],
    //                 order.inner_dia?.split(" ")[0] *
    //                   orderDim_Rewinder_Unit_Conversion[coreIdUnit]
    //               );
    //               order.quantity = Math.round(
    //                 parseFloat(plannedReels).toFixed(3)
    //               )
    //                 ? Math.round((parseFloat(plannedReels) * 1).toFixed(3))
    //                 : 1;
    //               order["planning_weight"] = order.weight;
    //             }
    //             let planned_weight = calculatePlannedWeight(
    //               parseFloat(widthData),
    //               productResp[0].bulk,
    //               order.outer_dia[0]?.split(" ")[0] *
    //                 orderDim_Rewinder_Unit_Conversion[reelOdUnit],
    //               order.inner_dia?.split(" ")[0] *
    //                 orderDim_Rewinder_Unit_Conversion[coreIdUnit],
    //               order.quantity
    //             );
    //             let plannedWt =
    //               planned_weight *
    //               conversionFactorTonneToUnits[order.weight_unit];
    //             order.planned_weight = plannedWt
    //               ? parseFloat(plannedWt).toFixed(3)
    //               : 0;

    //             let plannedWtConversion;
    //             if (
    //               productResp[0]?.units.per_weight_unit.toLowerCase() !==
    //               order?.per_weight_unit.toLowerCase()
    //             ) {
    //               order.per_weight_unit = productResp[0]?.units.per_weight_unit;
    //             }
    //             let netPrice;
    //             if (order.quantity_type == "weight") {
    //               netPrice =
    //                 parseFloat(order.dealer_price) *
    //                 parseFloat(order.weight)?.toFixed(3);
    //             }
    //             order.net_price = netPrice ? netPrice?.toFixed(3) : 0;
    //             order.quantity = Math.round(order.quantity);
    //           }
    //         } else if (order.type === "sheet") {
    //           let widthData = (
    //             order.width * orderDim_Rewinder_Unit_Conversion[order.size_unit]
    //           ).toFixed(3);
    //           let lengthData = (
    //             order.length *
    //             orderDim_Rewinder_Unit_Conversion[order.size_unit]
    //           ).toFixed(3);

    //           if (
    //             order.outer_dia?.length == 0 &&
    //             (order.inner_dia == 0 || order.inner_dia == "")
    //           ) {
    //             if (order.quantity_type === "reel_sheet") {
    //               let widthValue = parseFloat(widthData);
    //               let lengthValue = parseFloat(lengthData);
    //               order.weight_unit =
    //                 measurementData.data.units_management.weight.default;
    //               const plannedWeight =
    //                 (lengthValue *
    //                   widthValue *
    //                   order.no_of_reel_sheet *
    //                   productResp[0].gsm) /
    //                 (10000 * 1000000);
    //               let plannedWt =
    //                 plannedWeight *
    //                 conversionFactorTonneToUnits[order.weight_unit];
    //               order.planned_weight = plannedWt?.toFixed(3);
    //               order["planning_quantity"] = order.no_of_reel_sheet;
    //             } else {
    //               order.weight = order.weight?.toFixed(3);
    //               order.planned_weight = order.weight;
    //               order["planning_weight"] = order.weight;
    //               delete order.no_of_reel_sheet;
    //             }
    //             let plannedWtConversion;
    //             if (
    //               productResp[0]?.units.per_weight_unit.toLowerCase() !==
    //               order?.per_weight_unit.toLowerCase()
    //             ) {
    //               order.per_weight_unit = productResp[0]?.units.per_weight_unit;
    //             }
    //             if (
    //               order?.weight_unit?.toLowerCase() !==
    //               order?.per_weight_unit?.toLowerCase()
    //             ) {
    //               let unitToTonneConv =
    //                 order.planned_weight *
    //                 weight_Unit_Conversions[order?.weight_unit];
    //               plannedWtConversion =
    //                 unitToTonneConv *
    //                 conversionFactorTonneToUnits[order?.per_weight_unit];
    //             } else {
    //               plannedWtConversion = order.planned_weight;
    //             }
    //             const netPrice =
    //               parseFloat(order.dealer_price) *
    //               parseFloat(plannedWtConversion)
    //                 ? parseFloat(order.dealer_price) *
    //                   parseFloat(plannedWtConversion)
    //                 : "";
    //             order.net_price = netPrice ? netPrice?.toFixed(3) : 0;
    //           }
    //           order.quantity = Math.round(order.quantity);
    //         } else if (
    //           order.type === "reel" &&
    //           (!response.default_reel_od || !response.default_core_id)
    //         ) {
    //           if (
    //             order.type === "reel" &&
    //             order.quantity_type === "reel_sheet"
    //           ) {
    //             order.quantity = order.no_of_reel_sheet;
    //             order.weight_unit =
    //               measurementData.data.units_management.weight.default;
    //             order["planning_quantity"] = order.no_of_reel_sheet;
    //           } else {
    //             order.quantity = 0;
    //             order["planning_weight"] = order.weight;
    //           }
    //         }

    //         if (order.type == "sheet" && order.quantity_type == "reel_sheet") {
    //           order["planned_sheets"] = order.no_of_reel_sheet;
    //         }

    //         if (order.quantity_type === "weight") {
    //           let calculated_lower_tolerance = 0;
    //           let calculated_upper_tolerance = 0;
    //           if (order.weight) {
    //             let upperTol =
    //               (parseFloat(order.weight)?.toFixed(3) *
    //                 (100 + parseFloat(upperTolerance))) /
    //               100;
    //             let lowerTol =
    //               (parseFloat(order.weight)?.toFixed(3) *
    //                 (100 - parseFloat(lowerTolerance))) /
    //               100;
    //             calculated_lower_tolerance = lowerTol.toFixed(3);
    //             calculated_upper_tolerance = upperTol.toFixed(3);
    //           }
    //           order["tolerances"] = {
    //             weight: {
    //               upper_tolerance: parseFloat(upperTolerance),
    //               lower_tolerance: parseFloat(lowerTolerance),
    //               calculated_lower_tolerance: parseFloat(
    //                 calculated_lower_tolerance
    //               ),
    //               calculated_upper_tolerance: parseFloat(
    //                 calculated_upper_tolerance
    //               ),
    //               units: order.weight_unit
    //                 ? order.weight_unit
    //                 : measurementData.data.units_management.weight.default,
    //             },
    //           };
    //         } else {
    //           order["tolerances"] = {};
    //         }

    //         order["packaging_details"] = order.packaging_details.id;
    //         order.units = {
    //           weight: order.weight_unit
    //             ? order.weight_unit
    //             : measurementData.data.units_management.weight.default,
    //           ...(order.type === "sheet" && { length: order.size_unit }),
    //           width: order.size_unit,
    //           planned_weight:
    //             order.quantity_type === "reel_sheet"
    //               ? measurementData.data.units_management.weight.default
    //               : order.weight_unit,
    //           dealer_price: order.currency,
    //           customer_price: order.currency,
    //           net_price: order.currency,
    //           per_weight_unit: order?.per_weight_unit,
    //         };

    //         dataToSave.pos[index].orders[ele].order = order;
    //       }
    //     }
    //   }
    // } catch (error) {
    //   console.log(error);
    //   setLoadings(false);
    //   setResendApprovalLoading(false);
    //   setOtherButtonLoadingLoadings(false);
    //   setResendAppOtherButtonLoading(false);
    // }


    //changes with shahpaper and reel od core od new changes
    let dataToSave = reqData;
    try {
      const response = await getReelCoreValues();
      if (!response.error) {
        for (let index = 0; index < dataToSave.pos.length; index++) {
          if (
            dataToSave.pos[index].po["po/so"] === "so" &&
            dataToSave.pos[index].po.number
          ) {
            dataToSave.pos[index].po["reference_number"] =
              dataToSave.pos[index].po.number;
          } 
          else {
            const po = dataToSave.pos[index].po;
            // Always take only the original PO number (prevents duplicate append on retry).
            const basePoNumber = String(po.number ?? "").split("#%#")[0].trim();
            const customerCode = String(po.customer?.split(" - ")[0] ?? "")
              .split("#%#")[0]
              .trim();

            let poDate = "";
            const rawDate = po.date;
            if (rawDate !== undefined && rawDate !== null && rawDate !== "") {
              if (moment.isMoment(rawDate)) {
                poDate = rawDate.format("YYYY-MM-DD");
              } else {
                const parsedDate = moment(rawDate);
                poDate = parsedDate.isValid()
                  ? parsedDate.format("YYYY-MM-DD")
                  : String(rawDate).split("#%#")[0].trim();
              }
            }

            // Single separator after PO number only: {poNumber}#%#{customerCode}{poDate}
            po.number = `${basePoNumber}#%#${customerCode}${poDate}`;
          }
          for (let ele = 0; ele < dataToSave.pos[index].orders.length; ele++) {
            let order = dataToSave.pos[index].orders[ele].order;
            order["category"] = dataToSave.pos[index].po["po/so"];
            let productNo = order.product.split(" -");
            // if (
            //   dataToSave.pos[index].po["po/so"] === "so" &&
            //   dataToSave.pos[index].po.number
            // ) {
            //   dataToSave.pos[index].po["reference_number"] =
            //     dataToSave.pos[index].po.number;
            // }
            // if (dataToSave.pos[index].po["po/so"] === "so") {
            //   order.po = "";
            //   order.delivery_date = null;
            // }

            if (dataToSave.pos[index].po["po/so"] === "so") {
              order.po = "";
              order.delivery_date = null;

            } else {
              order.po = `${dataToSave.pos[index].po.number}`;
            }

            // await getProductDetails(productNo[0]).then((productResp) => {
            let productResp = products?.filter(
              (ele) => productNo[0] === ele.code
            );
            let coreIdUnit;
            let reelOdUnit;

            if (!order?.reel_od && !order?.core_id) {
              if (
                order.type === "reel" &&
                response.default_reel_od &&
                response.default_core_id
              ) {
                if (order.type === "reel") {
                  let widthData = (
                    order.width * orderDim_Rewinder_Unit_Conversion[order.size_unit]
                  ).toFixed(3);
                  let diaArr = [];
                  order.reel_od = response.default_reel_od
                    ? response.default_reel_od
                    : 0;
                  order.core_id = response.default_core_id
                    ? response.default_core_id
                    : 0;

                  // let productNo = order.product.split(" -");
                  // await getProductDetails(productNo[0]).then((productResp) => {
                  if (
                    (order.outer_dia?.length && order.inner_dia) ||
                    (order.outer_dia?.length &&
                      (order.inner_dia == 0 || order.inner_dia == ""))
                  ) {
                    coreIdUnit = response.default_reel_unit;
                    reelOdUnit = response.default_reel_unit;
                  } else if (order.outer_dia?.length == 0 && order.inner_dia) {
                    coreIdUnit = response.default_core_unit;
                    reelOdUnit = response.default_core_unit;
                  } else if (
                    order.outer_dia?.length == 0 &&
                    (order.inner_dia == 0 || order.inner_dia == "")
                  ) {
                    coreIdUnit =
                      measurementData.data.units_management.length.default;
                    reelOdUnit =
                      measurementData.data.units_management.length.default;
                  }

                  order.reel_od_unit = reelOdUnit;
                  order.core_id_unit = coreIdUnit;

                  order.units.core_id_unit = coreIdUnit;
                  order.units.reel_od_unit = reelOdUnit;
                  
                  let outerDiaArr = [];
                  outerDiaArr.push(response.default_reel_od + " " + reelOdUnit);
                  order.outer_dia = response.default_reel_od ? outerDiaArr : diaArr;
                  order.inner_dia = response.default_core_id
                    ? response.default_core_id + " " + coreIdUnit
                    : "";

                  if (
                    order.type === "reel" &&
                    order.quantity_type === "reel_sheet" &&
                    order.no_of_reel_sheet
                  ) {
                    order.quantity = order.no_of_reel_sheet;
                    order.weight_unit =
                      measurementData.data.units_management.weight.default;
                    order["planning_quantity"] = order.no_of_reel_sheet;
                  } else {
                    let plannedReels = calculatePlannedReels(
                      parseFloat(widthData),
                      order.weight * weight_Unit_Conversions[order.weight_unit],
                      productResp[0].bulk,
                      order.outer_dia[0]?.split(" ")[0] *
                      orderDim_Rewinder_Unit_Conversion[reelOdUnit],
                      order.inner_dia?.split(" ")[0] *
                      orderDim_Rewinder_Unit_Conversion[coreIdUnit]
                    );
                    order.quantity = Math.round(parseFloat(plannedReels).toFixed(3))
                      ? Math.round((parseFloat(plannedReels) * 1).toFixed(3))
                      : 1;
                    order["planning_weight"] = order.weight;
                  }
                  let planned_weight = calculatePlannedWeight(
                    parseFloat(widthData),
                    productResp[0].bulk,
                    parseFloat(order.outer_dia[0]?.split(" ")[0]) *
                    orderDim_Rewinder_Unit_Conversion[reelOdUnit],
                    parseFloat(order.inner_dia?.split(" ")[0]) *
                    orderDim_Rewinder_Unit_Conversion[coreIdUnit],
                    order.quantity
                  );
                  let plannedWt =
                    planned_weight *
                    conversionFactorTonneToUnits[order.weight_unit];
                  order.planned_weight = plannedWt
                    ? parseFloat(plannedWt).toFixed(3)
                    : 0;

                  let plannedWtConversion;
                  if (
                    productResp[0]?.units.per_weight_unit.toLowerCase() !==
                    order?.per_weight_unit.toLowerCase()
                  ) {
                    order.per_weight_unit = productResp[0]?.units.per_weight_unit;
                  }
                  // if(order?.weight_unit?.toLowerCase() !== order?.per_weight_unit?.toLowerCase()){
                  //   let unitToTonneConv = order.planned_weight * weight_Unit_Conversions[order?.weight_unit];
                  //   plannedWtConversion  = unitToTonneConv * conversionFactorTonneToUnits[order?.per_weight_unit];
                  // } else{
                  //     plannedWtConversion  = order.planned_weight;
                  // }
                  // const netPrice = parseFloat(order.dealer_price) * parseFloat(plannedWtConversion)
                  //       ? parseFloat(order.dealer_price) * parseFloat(plannedWtConversion)
                  //       : "";
                  let netPrice;
                  if (order.quantity_type == "weight") {
                    netPrice =
                      parseFloat(order.dealer_price) *
                      parseFloat(order.weight)?.toFixed(3);
                  }
                  order.net_price = netPrice ? netPrice?.toFixed(3) : 0;
                  order.quantity = Math.round(order.quantity);
                }
              } else if (order.type === "sheet") {
                let widthData = (
                  order.width * orderDim_Rewinder_Unit_Conversion[order.size_unit]
                ).toFixed(3);
                let lengthData = (
                  order.length * orderDim_Rewinder_Unit_Conversion[order.size_unit]
                ).toFixed(3);

                // if (!order?.core_id) {
                //   order.core_id = response.default_core_id ? response.default_core_id : 0;
                //   if (!order.units.core_id_unit) {
                //     order.units.core_id_unit = response.default_core_id
                //       ? response.default_core_unit
                //       : measurementData.data.units_management.default;
                //      order.core_id_unit = response.default_core_id
                //       ? response.default_core_unit
                //       : measurementData.data.units_management.default;
                //   }
                //   order.inner_dia = order.core_id + " " + (order?.units?.core_id_unit ? order?.units?.core_id_unit : order?.core_id_unit);
                // }

                if (
                  order.outer_dia?.length == 0 &&
                  (order.inner_dia == 0 || order.inner_dia == "")
                ) {
                  if (order.quantity_type === "reel_sheet") {
                    let widthValue = parseFloat(widthData);
                    let lengthValue = parseFloat(lengthData);
                    order.weight_unit =
                      measurementData.data.units_management.weight.default;
                    const plannedWeight =
                      (lengthValue *
                        widthValue *
                        order.no_of_reel_sheet *
                        productResp[0].gsm) /
                      (10000 * 1000000);
                    let plannedWt =
                      plannedWeight *
                      conversionFactorTonneToUnits[order.weight_unit];
                    order.planned_weight = plannedWt?.toFixed(3);
                    order["planning_quantity"] = order.no_of_reel_sheet;
                    // if(order.planned_weight){
                    //   let upperTol = (parseFloat(order.planned_weight)?.toFixed(3) * (100 + upperTolerance)) /100;
                    //   let lowerTol = (parseFloat(order.planned_weight)?.toFixed(3) * (100 - lowerTolerance)) /100;
                    //   // order.lower_tolerance = lowerTolerance;
                    //   // order.upper_tolerance = upperTolerance;
                    //   // order.calculated_lower_tolerance = lowerTol.toFixed(3);
                    //   // order.calculated_upper_tolerance = upperTol.toFixed(3);
                    // }else{
                    //   // order.lower_tolerance = lowerTolerance;
                    //   // order.upper_tolerance = upperTolerance;
                    //   // order.calculated_lower_tolerance = parseFloat(order.calculated_lower_tolerance)?.toFixed(3);
                    //   // order.calculated_upper_tolerance = parseFloat(order.calculated_upper_tolerance)?.toFixed(3);
                    // }
                  } else {
                    order.weight = order.weight?.toFixed(3);
                    const weightValue = parseFloat(order.weight);

                    Object.assign(order, {
                      planned_weight: weightValue,
                      planning_weight: weightValue,
                    });
                    // order["planned_weight"] = order.weight;
                    // order["planning_weight"] = order.weight;
                    // if(order.planned_weight){
                    //   let upperTol = (parseFloat(order.planned_weight)?.toFixed(3) * (100 + upperTolerance)) /100;
                    //   let lowerTol = (parseFloat(order.planned_weight)?.toFixed(3) * (100 - lowerTolerance)) /100;
                    //   order.lower_tolerance = lowerTolerance;
                    //   order.upper_tolerance = upperTolerance;
                    //   // order.calculated_lower_tolerance = lowerTol.toFixed(3);
                    //   // order.calculated_upper_tolerance = upperTol.toFixed(3);
                    // }else{
                    //   order.lower_tolerance = lowerTolerance;
                    //   order.upper_tolerance = upperTolerance;
                    //   // order.calculated_lower_tolerance = order.calculated_lower_tolerance?.toFixed(3);
                    //   // order.calculated_upper_tolerance = order.calculated_upper_tolerance?.toFixed(3);
                    // }
                    delete order.no_of_reel_sheet;
                  }
                  let plannedWtConversion;
                  if (
                    productResp[0]?.units.per_weight_unit.toLowerCase() !==
                    order?.per_weight_unit.toLowerCase()
                  ) {
                    order.per_weight_unit = productResp[0]?.units.per_weight_unit;
                  }
                  if (
                    order?.weight_unit?.toLowerCase() !==
                    order?.per_weight_unit?.toLowerCase()
                  ) {
                    let unitToTonneConv =
                      order.planned_weight *
                      weight_Unit_Conversions[order?.weight_unit];
                    plannedWtConversion =
                      unitToTonneConv *
                      conversionFactorTonneToUnits[order?.per_weight_unit];
                  } else {
                    plannedWtConversion = order.planned_weight;
                  }
                  const netPrice =
                    parseFloat(order.dealer_price) * parseFloat(plannedWtConversion)
                      ? parseFloat(order.dealer_price) *
                      parseFloat(plannedWtConversion)
                      : "";
                  order.net_price = netPrice ? netPrice?.toFixed(3) : 0;
                }
                order.quantity = Math.round(order.quantity);
              } else if (
                order.type === "reel" &&
                (!response.default_reel_od || !response.default_core_id)
              ) {
                if (order.type === "reel" && order.quantity_type === "reel_sheet") {
                  order.quantity = order.no_of_reel_sheet;
                  order.weight_unit =
                    measurementData.data.units_management.weight.default;
                  order["planning_quantity"] = order.no_of_reel_sheet;
                } else {
                  order.quantity = 0;
                  order["planning_weight"] = order.weight;
                }
              }
            } else {
              // if sheet and core id but no reel od = it will work like !reel and !core id
              if (order?.type == "sheet" && !order?.reel_od && order?.core_id) {
                let widthData = (
                  order.width * orderDim_Rewinder_Unit_Conversion[order.size_unit]
                ).toFixed(3);
                let lengthData = (
                  order.length * orderDim_Rewinder_Unit_Conversion[order.size_unit]
                ).toFixed(3);

                if (
                  order.outer_dia?.length == 0 &&
                  (order.inner_dia == 0 || order.inner_dia == "")
                ) {
                  order.inner_dia = order.core_id + " " + (order?.units?.core_id_unit ? order?.units?.core_id_unit : order?.core_id_unit);
                  if (order.quantity_type === "reel_sheet") {
                    let widthValue = parseFloat(widthData);
                    let lengthValue = parseFloat(lengthData);
                    order.weight_unit =
                      measurementData.data.units_management.weight.default;
                    const plannedWeight =
                      (lengthValue *
                        widthValue *
                        order.no_of_reel_sheet *
                        productResp[0].gsm) /
                      (10000 * 1000000);
                    let plannedWt =
                      plannedWeight *
                      conversionFactorTonneToUnits[order.weight_unit];
                    order.planned_weight = plannedWt?.toFixed(3);
                    order["planning_quantity"] = order.no_of_reel_sheet;
                  } else {
                    order.weight = order.weight?.toFixed(3);
                    order.planned_weight = order.weight;
                    order["planning_weight"] = order.weight;
                    delete order.no_of_reel_sheet;
                  }
                  let plannedWtConversion;
                  if (
                    productResp[0]?.units.per_weight_unit.toLowerCase() !==
                    order?.per_weight_unit.toLowerCase()
                  ) {
                    order.per_weight_unit = productResp[0]?.units.per_weight_unit;
                  }
                  if (
                    order?.weight_unit?.toLowerCase() !==
                    order?.per_weight_unit?.toLowerCase()
                  ) {
                    let unitToTonneConv =
                      order.planned_weight *
                      weight_Unit_Conversions[order?.weight_unit];
                    plannedWtConversion =
                      unitToTonneConv *
                      conversionFactorTonneToUnits[order?.per_weight_unit];
                  } else {
                    plannedWtConversion = order.planned_weight;
                  }
                  const netPrice =
                    parseFloat(order.dealer_price) * parseFloat(plannedWtConversion)
                      ? parseFloat(order.dealer_price) *
                      parseFloat(plannedWtConversion)
                      : "";
                  order.net_price = netPrice ? netPrice?.toFixed(3) : 0;
                }
                order.quantity = Math.round(order.quantity);
              } else {
                if (!order?.reel_od) {
                  order.reel_od = response.default_reel_od ? response.default_reel_od : 0;
                  if (!order.units.reel_od_unit) {
                    order.reel_od_unit = response.default_reel_od
                      ? response.default_reel_unit
                      : measurementData.data.units_management?.length?.default;
                    order.units.reel_od_unit = response.default_reel_od
                      ? response.default_reel_unit
                      : measurementData.data.units_management?.length?.default;
                  }
                }

                if (!order?.core_id) {
                  order.core_id = response.default_core_id ? response.default_core_id : 0;
                  if (!order.units.core_id_unit) {
                    order.core_id_unit = response.default_core_id
                      ? response.default_core_unit
                      : measurementData.data.units_management?.length?.default;
                    order.units.core_id_unit = response.default_core_id
                      ? response.default_core_unit
                      : measurementData.data.units_management?.length?.default;
                  }
                }

                let outerDiaArr = [];
                outerDiaArr.push(order?.reel_od + " " + (order?.reel_od_unit ? order?.reel_od_unit : measurementData.data.units_management?.length?.default));
                order.outer_dia = outerDiaArr;
                order.inner_dia = order.core_id + " " + (order?.core_id_unit ? order?.core_id_unit : measurementData.data.units_management?.length?.default);

                if (order.type === "reel") {
                  let widthData = (
                    order.width * orderDim_Rewinder_Unit_Conversion[order.size_unit]
                  ).toFixed(3);

                  if (
                    order.type === "reel" &&
                    order.quantity_type === "reel_sheet" &&
                    order.no_of_reel_sheet
                  ) {
                    order.quantity = order.no_of_reel_sheet;
                    order.weight_unit =
                      measurementData.data.units_management.weight.default;
                    order["planning_quantity"] = order.no_of_reel_sheet;
                  } else {
                    const innerDiaValue = parseFloat(
                      order.inner_dia?.split(" ")[0]
                    );
                    const outerDiaValue = parseFloat(
                      order.outer_dia?.[0]?.split(" ")[0]
                    );
                    if (innerDiaValue === 0 || outerDiaValue === 0) {
                      order.quantity = 0;
                      order["planning_weight"] = order.weight;
                    } else {
                      let plannedReels = calculatePlannedReels(
                        parseFloat(widthData),
                        order.weight *
                          weight_Unit_Conversions[order.weight_unit],
                        productResp[0].bulk,
                        order.outer_dia[0]?.split(" ")[0] *
                          orderDim_Rewinder_Unit_Conversion[
                            order?.reel_od_unit
                          ],
                        order.inner_dia?.split(" ")[0] *
                          orderDim_Rewinder_Unit_Conversion[
                            order?.core_id_unit
                          ]
                      );
                      order.quantity = Math.round(
                        parseFloat(plannedReels).toFixed(3)
                      )
                        ? Math.round((parseFloat(plannedReels) * 1).toFixed(3))
                        : 1;
                      order["planning_weight"] = order.weight;
                    }
                  }
                  //calculate planned weight
                  let planned_weight = calculatePlannedWeight(
                    parseFloat(widthData),
                    productResp[0].bulk,
                    parseFloat(order.outer_dia[0]?.split(" ")[0]) *
                    orderDim_Rewinder_Unit_Conversion[order.outer_dia[0]?.split(" ")[1]],
                    parseFloat(order.inner_dia?.split(" ")[0]) *
                    orderDim_Rewinder_Unit_Conversion[order.inner_dia?.split(" ")[1]],
                    order.quantity
                  );
                  let plannedWt =
                    planned_weight *
                    conversionFactorTonneToUnits[order.weight_unit];
                  order.planned_weight = plannedWt
                    ? parseFloat(plannedWt).toFixed(3)
                    : 0;

                  let plannedWtConversion;
                  if (
                    productResp[0]?.units.per_weight_unit.toLowerCase() !==
                    order?.per_weight_unit.toLowerCase()
                  ) {
                    order.per_weight_unit = productResp[0]?.units.per_weight_unit;
                  }
                  let netPrice;
                  if (order.quantity_type == "weight") {
                    netPrice =
                      parseFloat(order.dealer_price) *
                      parseFloat(order.weight)?.toFixed(3);
                  }
                  order.net_price = netPrice ? netPrice?.toFixed(3) : 0;
                  order.quantity = Math.round(order.quantity);

                }
                // else if (order.type === "reel" && (!order?.reel_od || !order?.core_id)) {
                //   if (order.type === "reel" && order.quantity_type === "reel_sheet") {
                //     order.quantity = order.no_of_reel_sheet;
                //     order.weight_unit =
                //       measurementData.data.units_management.weight.default;
                //     order["planning_quantity"] = order.no_of_reel_sheet;
                //   } else {
                //     order.quantity = 0;
                //     order["planning_weight"] = order.weight;
                //   }
                // } else
                else {
                  let size =
                    (order?.grain === "Long Grain" ||
                      order?.grain === "long" ||
                      order?.grain === "long grain"
                      ? parseFloat(order?.width) > parseFloat(order?.length)
                        ? order?.length
                        : order?.width
                      : parseFloat(order?.length) > parseFloat(order?.width)
                        ? order?.length
                        : order?.width);

                  let widthData = (
                    size * orderDim_Rewinder_Unit_Conversion[order.size_unit]
                  ).toFixed(3);

                  let quantityValue;
                  let plannedReels;

                  const innerDiaValue = parseFloat(
                      order.inner_dia?.split(" ")[0]
                    );
                    const outerDiaValue = parseFloat(
                      order.outer_dia?.[0]?.split(" ")[0]
                    );
                    if (innerDiaValue === 0 || outerDiaValue === 0) {
                      order.quantity = 0;
                      order["planning_weight"] = order.weight;
                      order["planned_weight"] = order.weight;
                    } else {
                      if (order?.quantity_type == "weight") {
                        quantityValue = order.weight * weight_Unit_Conversions[order.weight_unit];
                        plannedReels = plannedReelsCalculations(
                          parseFloat(widthData),
                          order?.length * orderDim_Rewinder_Unit_Conversion[order.size_unit],
                          order?.width * orderDim_Rewinder_Unit_Conversion[order.size_unit],
                          productResp[0].bulk,
                          productResp[0].gsm,
                          order.inner_dia?.split(" ")[0] * orderDim_Rewinder_Unit_Conversion[order?.units?.core_id_unit ? order?.units?.core_id_unit : order?.core_id_unit],
                          order.outer_dia[0]?.split(" ")[0] * orderDim_Rewinder_Unit_Conversion[order?.units?.reel_od_unit ? order?.units?.reel_od_unit : order?.reel_od_unit],
                          quantityValue,
                          order?.quantity_type
                        );
                        order.quantity = Math.round(parseFloat(plannedReels).toFixed(3))
                          ? Math.round((parseFloat(plannedReels) * 1).toFixed(3))
                          : 1;
                        order["planning_weight"] = order.weight;
                      } else {
                        //in ordertype = sheet && quantity type = sheet ? order?.no_of_reel_sheet means user entered value and same in planning qty
                        // quantity = calculated reels
                        quantityValue = order.no_of_reel_sheet;
                        plannedReels = plannedReelsCalculations(
                          parseFloat(widthData),
                          order?.length * orderDim_Rewinder_Unit_Conversion[order.size_unit],
                          order?.width * orderDim_Rewinder_Unit_Conversion[order.size_unit],
                          productResp[0].bulk,
                          productResp[0].gsm,
                          order.inner_dia?.split(" ")[0] * orderDim_Rewinder_Unit_Conversion[order?.units?.core_id_unit ? order?.units?.core_id_unit : order?.core_id_unit],
                          order.outer_dia[0]?.split(" ")[0] * orderDim_Rewinder_Unit_Conversion[order?.units?.reel_od_unit ? order?.units?.reel_od_unit : order?.reel_od_unit],
                          quantityValue,
                          order?.quantity_type
                        );
                        order.quantity = Math.round(parseFloat(plannedReels).toFixed(3))
                          ? Math.round((parseFloat(plannedReels) * 1).toFixed(3))
                          : 1;
                        order["planning_quantity"] = order.no_of_reel_sheet;
                      }

                      //calculate planned weight
                      let planned_weight = calculatePlannedWeight(
                        parseFloat(widthData),
                        productResp[0].bulk,
                        parseFloat(order.outer_dia[0]?.split(" ")[0]) * orderDim_Rewinder_Unit_Conversion[order.outer_dia[0]?.split(" ")[1]],
                        parseFloat(order.inner_dia?.split(" ")[0]) * orderDim_Rewinder_Unit_Conversion[order.inner_dia?.split(" ")[1]],
                        order.quantity
                      );
                      let plannedWt =
                        planned_weight *
                        conversionFactorTonneToUnits[order.weight_unit];
                      order.planned_weight = plannedWt
                        ? parseFloat(plannedWt).toFixed(3)
                        : 0;
                    }

                  if (
                    productResp[0]?.units.per_weight_unit.toLowerCase() !==
                    order?.per_weight_unit.toLowerCase()
                  ) {
                    order.per_weight_unit = productResp[0]?.units.per_weight_unit;
                  }
                  let netPrice;
                  if (order.quantity_type == "weight") {
                    netPrice =
                      parseFloat(order.dealer_price) *
                      parseFloat(order.weight)?.toFixed(3);
                  }
                  order.net_price = netPrice ? netPrice?.toFixed(3) : 0;
                  order.quantity = Math.round(order.quantity);
                }
                if(order?.reel_od == 0){
                  let outerDiaArrValue = [];
                  order.outer_dia = outerDiaArrValue;
                }
                if(order?.core_id == 0){
                  order.inner_dia = "";
                }
              }
            }

            if (order.type == "sheet" && order.quantity_type == "reel_sheet") {
              order["planned_sheets"] = order.no_of_reel_sheet;
            }

            if (order.quantity_type === "weight") {
              let calculated_lower_tolerance = 0;
              let calculated_upper_tolerance = 0;
              if (order.weight) {
                let upperTol =
                  (parseFloat(order.weight)?.toFixed(3) *
                    (100 + parseFloat(upperTolerance))) /
                  100;
                let lowerTol =
                  (parseFloat(order.weight)?.toFixed(3) *
                    (100 - parseFloat(lowerTolerance))) /
                  100;
                calculated_lower_tolerance = lowerTol.toFixed(3);
                calculated_upper_tolerance = upperTol.toFixed(3);
              }
              order["tolerances"] = {
                weight: {
                  upper_tolerance: parseFloat(upperTolerance),
                  lower_tolerance: parseFloat(lowerTolerance),
                  calculated_lower_tolerance: parseFloat(
                    calculated_lower_tolerance
                  ),
                  calculated_upper_tolerance: parseFloat(
                    calculated_upper_tolerance
                  ),
                  units: order.weight_unit
                    ? order.weight_unit
                    : measurementData.data.units_management.weight.default,
                },
              };
            } else {
              order["tolerances"] = {};
            }

            order["packaging_details"] = order?.packaging_details?.id;
            order["ply"] = parseFloat(order.ply);
            order.units = {
              weight: order.weight_unit
                ? order.weight_unit
                : measurementData.data.units_management.weight.default,
              ...(order.type === "sheet" && { length: order.size_unit }),
              width: order.size_unit,
              planned_weight:
                order.quantity_type === "reel_sheet"
                  ? measurementData.data.units_management.weight.default
                  : order.weight_unit,
              // ...order.type === "sheet" && {calculated_upper_tolerance: order.quantity_type === "reel_sheet" ? measurementData.data.units_management.weight.default : order.weight_unit},
              // ...order.type === "sheet" && {calculated_lower_tolerance: order.quantity_type === "reel_sheet" ? measurementData.data.units_management.weight.default : order.weight_unit},
              // core_id: order.type === "sheet" ? measurementData?.data.units_management.length.default : coreIdUnit,
              // reel_od: order.type === "sheet" ? measurementData?.data.units_management.length.default : reelOdUnit,
              dealer_price: order.currency,
              customer_price: order.currency,
              net_price: order.currency,
              per_weight_unit: order?.per_weight_unit,
            };
            // dataToSave.pos[0].orders[index].order = order;
            dataToSave.pos[index].orders[ele].order = order;
            // });
          }
        }
      }
    } catch (error) {
      console.log(error);
      setLoadings(false);
      setResendApprovalLoading(false);
      setOtherButtonLoadingLoadings(false);
      setResendAppOtherButtonLoading(false);
    }
    console.log(dataToSave);


    //calculating payload size
    let requestData = JSON.stringify(dataToSave);
    let sizeInBytes = new Blob([requestData]).size;
    let sizeINMB = sizeInBytes / (1024 * 1024);

    if (sizeINMB > 100) {
      setLoadings(false);
      setResendApprovalLoading(false);
      setOtherButtonLoadingLoadings(false);
      setResendAppOtherButtonLoading(false);
      setActionToaster({
        error: true,
        msg: "There are too many records to be uploaded at once in the file. Please reduce the records in the file and upload again.",
      });
      showToaster();
    } else {
      // logic for POS and ORDERS fragmentation
      let count = 0;
      let pos = dataToSave;
      for (let i = 0; i < pos.pos.length; i++) {
        count += pos.pos[i].orders.length;
      }
      // console.log("Total order in excel", count);

      const orderThreshold = 500;
      const maxPOsPerGroup = 100;
      const slicedData = [];
      let tempGroup = [];
      let currentOrderCount = 0;
      const posList = pos.pos;
      for (let i = 0; i < posList.length; i++) {
        const currentPO = posList[i];
        const orderLength = currentPO.orders.length;
        if (orderLength > orderThreshold) {
          if (tempGroup.length > 0) {
            slicedData.push(tempGroup);
            tempGroup = [];
            currentOrderCount = 0;
          }
          slicedData.push([currentPO]);
          continue;
        }
        const exceedOrderLimit =
          currentOrderCount + orderLength > orderThreshold;
        const exceedPOCount = tempGroup.length + 1 > maxPOsPerGroup;

        if (exceedOrderLimit || exceedPOCount) {
          slicedData.push(tempGroup);
          tempGroup = [currentPO];
          currentOrderCount = orderLength;
        } else {
          tempGroup.push(currentPO);
          currentOrderCount += orderLength;
        }
      }
      if (tempGroup.length > 0) {
        slicedData.push(tempGroup);
      }
      slicedData.forEach((group, index) => {
        let count = 0;
        group.forEach((grp) => {
          count += grp.orders.length;
        });
        // console.log(`${index} group order count`, count);
      });

      // console.log("Final grouped POs:", slicedData);

      // await saveUploadedOrders(dataToSave, location.state.format)
      //   .then((response) => {
      //     if (!response.error) {
      //       setSavedState(true);
      //     } else {
      //       setSavedState(false);
      //     }
      //     let poSavedData = JSON.parse(JSON.stringify(poData.current));

      //     //     // for(let ele = 0; ele < dataToSave.pos.length; ele++){
      //     //     //   let indexOfPO = poSavedData.data.pos.findIndex((data) => data.po.number == dataToSave.pos[ele].po.number)
      //     //     //   poSavedData.data.pos[indexOfPO]['isPOSaved'] = true;
      //     //     // }

      //     //to remove pos, saved from po page
      //     for (let ele = 0; ele < dataToSave.pos.length; ele++) {
      //       let indexOfPO = poSavedData.data.pos.findIndex(
      //         (data) => data.po.number == dataToSave.pos[ele].po.number
      //       );
      //       if (indexOfPO != -1 && indexOfPO >= 0) {
      //         poSavedData.data.pos.splice(indexOfPO, 1);
      //       }
      //     }

      //     // to remove pos, saved from orders page
      //     for (let item = 0; item < poSavedData.data.pos.length; item++) {
      //       let savedPOArr = poSavedData.data.pos.findIndex(
      //         (data) => data.isPOSaved
      //       );
      //       if (savedPOArr != -1 && savedPOArr >= 0) {
      //         poSavedData.data.pos.splice(savedPOArr, 1);
      //       }
      //     }

      //     poData.current = JSON.parse(JSON.stringify(poSavedData));
      //     setSelectedPOs(poSavedData);
      //     if (!poSavedData?.data?.pos?.length) {
      //       setEmptyStateLabel("noData");
      //       setDisabledButton(true);
      //     }
      //     setActionToaster({
      //       error: response.error,
      //       msg: "Orders are successfully uploaded",
      //     });
      //     showToaster();
      //     setLoadings(false);
      //     setResendApprovalLoading(false);
      //     setOtherButtonLoadingLoadings(false);
      //     setResendAppOtherButtonLoading(false);
      //     setRerendering(true);
      //   })
      //   .catch((error) => {
      //     setLoadings(false);
      //     setResendApprovalLoading(false);
      //     setOtherButtonLoadingLoadings(false);
      //     setResendAppOtherButtonLoading(false);
      //     setActionToaster({
      //       error: error.response?.data?.error,
      //       msg: error.response?.data?.msg,
      //     });
      //     showToaster();
      //   });
      const uploadPromises = slicedData.map((group, index) => {
        const groupPayload = {
          ...dataToSave,
          pos: group,
        };

        return saveUploadedOrders(groupPayload, location.state.format)
          .then((response) => ({
            success: true,
            response,
            group,
            index,
          }))
          .catch((error) => ({
            success: false,
            error,
            group,
            index,
          }));
      });

      const allResponses = await Promise.all(uploadPromises);
      let poSavedData = JSON.parse(JSON.stringify(poData.current));
      allResponses.forEach(({ success, response, group }) => {
        if (success && !response.error) {
          for (let ele = 0; ele < group.length; ele++) {
            const poNumber = group[ele].po.number;
            const indexOfPO = poSavedData.data.pos.findIndex(
              (data) => data.po.number === poNumber
            );
            if (indexOfPO !== -1) {
              poSavedData.data.pos.splice(indexOfPO, 1);
            }
          }
        }
      });
      for (let item = 0; item < poSavedData.data.pos.length; item++) {
        const savedPOIndex = poSavedData.data.pos.findIndex(
          (data) => data.isPOSaved
        );
        if (savedPOIndex !== -1) {
          poSavedData.data.pos.splice(savedPOIndex, 1);
        }
      }
      poData.current = JSON.parse(JSON.stringify(poSavedData));
      setSelectedPOs(poSavedData);
      if (!poSavedData?.data?.pos?.length) {
        setEmptyStateLabel("noData");
        setDisabledButton(true);
      }
      const hasError = allResponses.some(
        (res) => !res.success || res.response?.error
      );
      setActionToaster({
        error: hasError,
        msg: hasError
          ? "Some groups failed to upload"
          : "All orders successfully uploaded",
      });
      showToaster();
      setLoadings(false);
      setResendApprovalLoading(false);
      setOtherButtonLoadingLoadings(false);
      setResendAppOtherButtonLoading(false);
      setRerendering(true);
    }
  };

  const saveDetails = () => {
    setSaveDataModal({
      visible: true,
      data: poData,
      type: orderManagementSettings?.data?.approval_flow?.value ? "pending" : "approved"
    });
  };

  const showToaster = () => {
    setVisibleToaster(true);
    setTimeout(() => setVisibleToaster(false), 2500);
  };

  const handlePageClick = (selectedPage) => {
    setShimmerState(true);
    setCurrentPage(selectedPage.selected + 1);
    setTimeout(() => {
      setShimmerState(false);
    }, 2000);
  };


  const isDisabled = (input,field) => {
    return !(input?.errors?.hasOwnProperty(field));
  }

  useEffect(() => {
    (async () => {
      getProductsData({ status: "active" })
        .then((response) => {
          setProducts(response);
        })
        .catch((error) => {
          console.log("Error in fetching products list:", error);
        });

      getMachineGradeSelect()
        .then((response) => {
          setUpperTol(
            response?.data?.data?.settings?.order_types[2]?.data
              ?.order_tolerance?.upper_tolerance
          );
          setLowerTol(
            response?.data?.data?.settings?.order_types[2]?.data
              ?.order_tolerance?.lower_tolerance
          );
        })
        .catch((error) => console.log(error));

      let orderMangtSettings = await getWorkflowSettings("order_management");
      setOrderManagementSettings(orderMangtSettings);

      try {
        const unitData = await getUnitData();
        if (!unitData.error) {
          setMeasurementData(unitData);
        }
      } catch (err) {
        console.log(err);
      }
    })();
    return () => {
      setProducts([]);
    };
  }, []);

  useEffect(() => {
    setShimmerState(true);
    setCurrentPage(location?.state?.currentPage ? location.state.currentPage : 1);
    let POData = selectedPOs;
    let refPOData = JSON.parse(JSON.stringify(poData.current));
    for (let index = 0; index < selectedPOs.data.pos.length; index++) {
      let poData = selectedPOs.data.pos[index];
      let isErr = false;
      selectedPOs.data.pos[index].orders?.map((ele) => {
        if (ele.error_count > 0) {
          isErr = true;
          return;
        }
      });
      const countries = Country.getAllCountries();
      //customer.customer["countries"] = countries;
      poData.po["isErr"] = isErr;
      poData.po["delivery_countries"] = countries;
      poData.po["shipping_countries"] = countries;
      poData.po["billing_countries"] = countries;
      poData.po["deliverToCustomer"] = poData.po.hasOwnProperty(
        "deliverToCustomer"
      )
        ? poData.po["deliverToCustomer"]
        : false;
      poData.po["shipToCustomer"] = poData.po.hasOwnProperty("shipToCustomer")
        ? poData.po["shipToCustomer"]
        : false;
      poData.po["billToCustomer"] = poData.po.hasOwnProperty("billToCustomer")
        ? poData.po["billToCustomer"]
        : true;
      poData.po["deliverToConsignee"] = poData.po.hasOwnProperty(
        "deliverToConsignee"
      )
        ? poData.po["deliverToConsignee"]
        : true;
      poData.po["shipToConsignee"] = poData.po.hasOwnProperty("shipToConsignee")
        ? poData.po["shipToConsignee"]
        : true;
      poData.po["billToConsignee"] = poData.po.hasOwnProperty("billToConsignee")
        ? poData.po["billToConsignee"]
        : false;
      if (!poData.errors.customer) {
        const filteredCountry = countries.filter(
          (country) =>
            country.name?.toUpperCase() ===
            poData.po.delivery_country?.toUpperCase()
        );
        if (filteredCountry?.length) {
          const states = State.getStatesOfCountry(filteredCountry[0].isoCode);
          poData.po["delivery_states"] = states;

          const filteredConsigneeCountry = countries.filter(
            (country) =>
              country.name.toUpperCase() ===
              poData.po?.shipping_country?.toUpperCase()
          );
          if (filteredConsigneeCountry.length) {
            const consigneeStates = State.getStatesOfCountry(
              filteredConsigneeCountry[0].isoCode
            );
            poData.po["shipping_states"] = consigneeStates;
            poData.po["billing_states"] = consigneeStates;
          } else {
            poData.po["shipping_states"] = [];
            poData.po["billing_states"] = [];
          }
        } else {
          poData.po["delivery_states"] = [];
          poData.po["shipping_states"] = [];
          poData.po["billing_states"] = [];
        }
      } else {
        poData.po["delivery_states"] = [];
        if (!poData.errors.consignee && poData.po.hasOwnProperty("consignee")) {
          const filteredConsigneeCountry = countries.filter(
            (country) =>
              country?.name?.toUpperCase() ===
              poData?.po?.shipping_country?.toUpperCase()
          );

          if (filteredConsigneeCountry?.length) {
            const consigneeStates = State.getStatesOfCountry(
              filteredConsigneeCountry[0].isoCode
            );
            poData.po["shipping_states"] = consigneeStates;
            poData.po["billing_states"] = consigneeStates;
          } else {
            poData.po["shipping_states"] = [];
            poData.po["billing_states"] = [];
          }
        } else {
          poData.po["shipping_states"] = [];
          poData.po["billing_states"] = [];
        }
      }

      POData.data.pos[index] = poData;
      refPOData.data.pos[index] = poData;
    }
    poData.current = JSON.parse(JSON.stringify(refPOData));
    setSelectedPOs(POData);
    getCustomers({ status: "active" })
      .then((response) => {
        setCustomerList(response);
      })
      .catch((error) => {
        console.log(error);
      });
    setTimeout(() => {
      setShimmerState(false);
    }, 3000);
  }, []);

  useEffect(() => {
    let propsData = {};
    if (emptyStateLabel === "noData") {
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "No pending Purchase Orders to save";
      propsData["subHeading"] =
        "There are no pending orders to save in this list. Please upload a new file to save more purchase orders";
      propsData["type"] = "PO";
    }
    setEmptyStatePropsData(propsData);
  }, [emptyStateLabel]);

  useEffect(() => {
    document.body.style.overflow = "hidden";
    if (rerendering) {
      form.resetFields();
      setRerendering(false);
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [rerendering]);

  const offset = (currentPage - 1) * itemsPerPage;

  const currentPageData = selectedPOs.data.pos
    .slice(offset, offset + itemsPerPage)
    .map((input, index) => {
      // console.log(index);
      const failedOrders = input.orders.filter((e) => e.error_count > 0).length;
      const verifiedOrders = input.orders.filter((e) => e.error_count == 0).length;
      return input.po[["po/so"]] === "so" ? (
        <SoValidation
          offset={offset}
          resendAppLoading={resendAppLoading}
          loadings={loadings}
          redirectToViewOrders={redirectToViewOrders}
          input={input}
          index={index}
          onPoDateChange={onPoDateChange}
        />
      ) : (
        <Row
          gutter={[16, 10]}
          className="groupForm"
          style={{
            minWidth:"100vw",
            marginBottom: "10px",
            paddingBottom: "10px",
          }}
        >
          <Col span={1} style={{ paddingTop: "40px" }}>
            <Styled>
              {/* {(input.error_count || input.errors.hasOwnProperty(input)) && */}
              <Tooltip
                placement="bottomRight"
                title={
                  input.error_count || Object.keys(input.errors).length > 0
                    ? "This PO has failed validation"
                    : input.isPOSaved
                    ? "This PO is saved"
                    : ""
                }
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                <div style={{ cursor: "default" }}>
                  <Iconmoon
                    icon={
                      input.error_count || Object.keys(input.errors).length > 0 || failedOrders>0
                        ? "wrong"
                        : input.isPOSaved
                        ? "correct"
                        : ""
                    }
                    size={14}
                    color={
                      input.error_count || Object.keys(input.errors).length > 0 || failedOrders>0
                        ? "#EA655B"
                        : input.isPOSaved
                        ? "#3FBD61"
                        : ""
                    }
                  />
                </div>
              </Tooltip>
              {/* } */}
            </Styled>
          </Col>
          <Col span={2}>
            <div className="boxFormType">
              <Form.Item
                label="S.No."
                name={`sno${offset + index}`}
                rules={[]}
                className="dBlock"
                initialValue={offset + (index + 1)}
              >
                <Input disabled style={{ textTransform: "capitalize", paddingInline:"0px"}} />
              </Form.Item>
            </div>
          </Col>
          <Col span={3}>
            <div className="boxFormType">
              <Form.Item
                label="PO Number"
                name={`poNumber${offset + index}`}
                rules={[
                  {
                    required: true,
                    message: "PO number is required",
                  },
                ]}
                className="dBlock"
                initialValue={toHandlePOName(input.po.number)}
                validateStatus={
                  input.errors.hasOwnProperty("number") ? "error" : null
                }
                // help={input.errors.hasOwnProperty('number') ? input.errors.number : null}
              >
                <Input
                  disabled
                  placeholder=""
                  onChange={() => onPONumberChange(offset + index, input)}
                  style={{ textTransform: "capitalize" }}
                />
              </Form.Item>
            </div>
            {input.errors.hasOwnProperty("number") ? (
              <span className="errorText" style={{ color: "#ea4e2c" }}>
                {input.errors.number}
              </span>
            ) : null}
          </Col>
          <Col  span={4}>
            <DatePickerY>
              <Form.Item
                label="PO Date"
                name={`PODate${offset + index}`}
                rules={[
                  {
                    required: true,
                    message: "This field is required",
                  },
                ]}
                className="dBlock"
                initialValue={
                  input.errors.hasOwnProperty("date")
                    ? ""
                    : input.po.date
                    ? moment(input.po.date)
                    : null
                }
                validateStatus={
                  input.errors.hasOwnProperty("date") ? "error" : null
                }

                //help={input.errors.hasOwnProperty('date') ? input.errors.date : null}
              >
                <DatePicker
                  placeholder="Select date"
                  format={"DD/MM/YYYY"}
                  Cannot
                  select
                  days
                  before
                  today
                  for
                  PO
                  date
                  disabledDate={(current) => {
                    return current && current < moment().subtract(1, "day");
                  }}
                  onChange={() => onPoDateChange(offset + index, input)}
                  disabled={isDisabled(input,"date")}
                />
              </Form.Item>
            </DatePickerY>
            {input.errors.hasOwnProperty("date") ? (
              <span className="errorText" style={{ color: "#ea4e2c" }}>
                {input.errors.date}
              </span>
            ) : null}
          </Col>
          <Col span={4}>
            <div className="boxFormType">
              <Form.Item
                label="Customer"
                name={`customer${offset + index}`}
                rules={[
                  {
                    required: true,
                    message: "This field is required",
                  },
                  {
                    max: 50,
                    message: "Name can have a maximum of 50 characters",
                  },
                ]}
                className="dBlock"
                initialValue={input?.po?.customer}
                validateStatus={
                  input.errors.hasOwnProperty("customer") ? "error" : null
                }
                // help={input.errors.hasOwnProperty('customer') ? input.errors.customer : null}
              >
                <Select
                  showSearch
                  name="customer"
                  suffixIcon={
                    isCustomerDropdownOpen ? (
                      <DropDownSearchDraw />
                    ) : (
                      <DownArrowDraw />
                    )
                  }
                  onBlur={OntoggleSelect}
                  onFocus={OntoggleSelect}
                  optionFilterProp="children"
                  onChange={() => customerHandler(offset + index, input)}
                  placeholder="Select Customer"
                  disabled={isDisabled(input,"customer")}
                >
                  {customerList.map((cust) => (
                    <Option key={cust.code}>
                      {cust.code} - {cust.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
            {input.errors.hasOwnProperty("customer") ? (<>
              <p className="errorText" style={{ color: "#ea4e2c"}}>
                {input.errors.customer}
              </p>
                {input.errors.customer !== "customer is empty" && ( 
                  <Button className="textTypeBtn" style={{ margin:"1px 2px 1px auto",display:"flex",alignItems:"center",gap:"3px"}} onClick={()=>addNewCustomer(input)}>
                    <Iconmoon icon="addcircle" color="#ea4e2c" size={12}/>
                    Add Customer
                </Button>)}
              </>
            ) : null}
          </Col>
          {/* <Col span={4}>
            <div className="boxFormType">
              <Form.Item
                label="Consignee"
                name={`consignee${offset + index}`}
                rules={[
                  {
                    required: true,
                    message: "This field is required",
                  },
                  {
                    max: 50,
                    message: "Name can have a maximum of 50 characters",
                  },
                ]}
                className="dBlock"
                initialValue={input.po.consignee}
                validateStatus={
                  input.errors.hasOwnProperty("consignee") ? "error" : null
                }
                // help={input.errors.hasOwnProperty('customer') ? input.errors.customer : null}
              >
                <Select
                  showSearch
                  name="consignee"
                  suffixIcon={
                    isCustomerDropdownOpen ? (
                      <DropDownSearchDraw />
                    ) : (
                      <DownArrowDraw />
                    )
                  }
                  onBlur={OntoggleSelect}
                  onFocus={OntoggleSelect}
                  optionFilterProp="children"
                  onChange={() => consigneeHandler(offset + index, input)}
                  placeholder="Select consignee"
                  disabled={isDisabled(input,"consignee")}
                >
                  {customerList.map((cust) => (
                    <Option key={cust.code}>
                      {cust.code} - {cust.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
            {input.errors.hasOwnProperty("consignee") ? (
              <>
                <p className="errorText" style={{ color: "#ea4e2c" }}>
                  {input.errors.consignee}
                </p>
                <Button className="textTypeBtn" style={{ margin:"1px 2px 1px auto",display:"flex",alignItems:"center",gap:"3px"}} onClick={()=>addNewConsignee(input)}>
                  <Iconmoon icon="addcircle" color="#ea4e2c" size={12}/>
                  Add Consignee
                </Button>
              </>
            ) : null}
          </Col> */}
          <Col span={3}>
            <Row>
              <Form.Item
                label="Order Summary"
                name={`orderSummary${offset + index}`}
                className="dBlock"
              >
                Failed Orders :{" "}
                {failedOrders}
              </Form.Item>
            </Row>
            <Row>
              <Form.Item name="orderSummary" className="dBlock">
                Verified Orders :{" "}
                {verifiedOrders}
              </Form.Item>
            </Row>
          </Col>
          <Col span={3}>
            <div className="boxFormType">
              <Form.Item
                label="Action"
                name={`action${offset + index}`}
                rules={[]}
                className="dBlock"
              >
                <Button
                  key="3"
                  className="textTypeBtn"
                  disabled={loadings || resendAppLoading}
                  onClick={() => redirectToViewOrders(offset + index, input)}
                >
                  View Orders
                </Button>
              </Form.Item>
            </div>
          </Col>
        </Row>

      );
    });

  return (
    <RightLayoutContainer>
      <PageTitleComp
        className="marginRightAdg"
        style={{ marginBottom: "12px" }}
      >
        <PageHeader
          title="Upload Result"
          extra={[
            <Button
              key="1"
              className="themeBtn noBg"
              onClick={() => history("../order-records")}
              disabled={otherButtonLoading || resendAppOtherButtonLoading}
            >
              <Iconmoon icon="export" size={14} color="#EA655B" />
              Go to Order Records
            </Button>,
            <Button
              key="2"
              className="themeBtn noBg"
              onClick={() => history("../order-records/upload-po")}
              disabled={otherButtonLoading || resendAppOtherButtonLoading}
            >
              <Iconmoon icon="import" size={14} color="#EA655B" />
              Upload Again
            </Button>,
            <Button
              key="3"
              className={`themeBtn`}
              onClick={() => saveDetails()}
              loading={loadings}
              disabled={
                disabledFilterButton ||
                !products?.length ||
                resendAppOtherButtonLoading ||
                (!selectedPOs && selectedPOs?.data?.pos?.length != 0)
              }
            >
              {!loadings && (
                <Iconmoon icon="addcircle" size={14} color="#ffffff" />
              )}
              {!loadings ? "Save Details" : ""}
            </Button>,
          ]}
        ></PageHeader>
      </PageTitleComp>

      {/* <div className="showPriorityOrder" style={{ display: "flex", justifyContent: 'space-between', marginBottom: "10px" }}>
        <div style={{marginTop: "10px", fontSize: "14px", fontFamily: "var(--sf-pro-display)", lineHeight: "16px"}}></div>
        <div style={{ display: "flex", flexDirection: "row" }}>
            <div>
              <DisabledButtonStyle style={{displayFlex: 'end'}}>
                <Button
                  className={
                    show
                      ? "themeBtn noBg approveAllOrders"
                      : "themeBtn noBg disabledstyle approve-header"
                  }
                  disabled={disabledFilterButton}
                  onClick={() => { setShow(!show); filterRecords(!show); }}
                >
                  <Iconmoon icon="filter" size={16} color="#605E5C" />{" "}
                  {show ? "Show All PO" : "Show Only Failed PO"}
                </Button>
              </DisabledButtonStyle>
            </div>
            <div style={{marginTop: "10px", marginRight: "15px", fontSize: "14px", fontFamily: "var(--sf-pro-display)", lineHeight: "16px"}}>Failed PO: 
            {(poData.current.data.pos.filter(e => (e.error_count > 0 || e.po.isErr))).length}
            </div>
            <div style={{marginTop: "10px", fontSize: "14px", fontFamily: "var(--sf-pro-display)", lineHeight: "16px"}}>Verified PO: 
            {(poData.current.data.pos.filter(e => (e.error_count == 0 && !e.po.isErr))).length}
            </div>
        </div>
      </div> */}

      <DetailFields>
        <HaberForm>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              marginBottom: "20px",
              justifyContent: "flex-end",
            }}
          >
            <DisabledButtonStyle style={{ marginTop: "-5px" }}>
              <Button
                className={
                  show
                    ? "themeBtn noBg approveAllOrders"
                    : "themeBtn noBg disabledstyle approve-header"
                }
                disabled={disabledFilterButton || loadings || resendAppLoading}
                onClick={() => {
                  setShow(!show);
                  filterRecords(!show);
                }}
              >
                <Iconmoon icon="filter" size={16} color="#605E5C" />{" "}
                {show ? "Show All PO/SO" : "Show Only Failed PO/SO"}
              </Button>
            </DisabledButtonStyle>
            <div
              style={{
                marginTop: "13px",
                marginRight: "15px",
                fontSize: "14px",
                fontFamily: "var(--sf-pro-display)",
                lineHeight: "16px",
              }}
            >
              Failed PO/SO:
              {
                poData.current.data.pos.filter(
                  (e) => e.error_count > 0 || e.po.isErr
                ).length
              }
            </div>
            <div
              style={{
                marginTop: "13px",
                marginRight: "15px",
                fontSize: "14px",
                fontFamily: "var(--sf-pro-display)",
                lineHeight: "16px",
              }}
            >
              Verified PO/SO:
              {
                poData.current.data.pos.filter(
                  (e) => e.error_count == 0 && !e.po.isErr
                ).length
              }
            </div>
            <ReactPaginate
              previousLabel={"Prev"}
              nextLabel={"Next"}
              breakLabel={"..."}
              breakClassName={"break-me"}
              pageCount={Math.ceil(selectedPOs.data.pos.length / itemsPerPage)}
              marginPagesDisplayed={1}
              pageRangeDisplayed={5}
              onPageChange={handlePageClick}
              containerClassName={"pagination"}
              subContainerClassName={"pages pagination"}
              activeClassName={"active"}
              forcePage={currentPage - 1}
              previousClassName={currentPage === 1 ? "disabled" : ""}
              previousLinkClassName={
                currentPage === 1
                  ? "prev-button-radius disabled"
                  : "prev-button-radius"
              }
              nextClassName={
                currentPage ===
                Math.ceil(selectedPOs.data.pos.length / itemsPerPage)
                  ? "next-button-radius disabled"
                  : "next-button-radius"
              }
              nextLinkClassName={"next-button-radius"}
            />
          </div>
          <div className="groupDetailWrap">
            <Form
              form={form}
              name="basic"
              autoComplete="off"
              className="haberLogin"
              // onFinish={onFinish}
            >
              <div
                style={{
                  overflow: "auto",
                  width: window.screen.width < 1500 ? "103.5%" : "102%",
                  height: window.screen.width > 1400 ? "600px" : "400px"
                }}
              >
                {shimmerState ? (
                  <TableShimmer
                    header={columnsHead.current}
                    type={"PO Upload"}
                  />
                ) : selectedPOs?.data?.pos?.length ? (
                  <>{currentPageData}</>
                ) : (
                  disabledFilterButton && (
                    <EmptyState
                      img={emptyState_NoData}
                      heading={emptyStatePropsData?.heading}
                      subHeading={emptyStatePropsData?.subHeading}
                      label={emptyStatePropsData?.label}
                      type={emptyStatePropsData?.type}
                    />
                  )
                )}
              </div>
            </Form>
          </div>
        </HaberForm>
      </DetailFields>

      {visibleToaster && !actionToaster.error && (
        <AlertContainer
          color="green toaster"
          icon={alertGreen}
          msg={actionToaster.msg}
        />
      )}
      {visibleToaster && actionToaster.error && (
        <AlertContainer
          color="red toaster"
          icon={alertRed}
          msg={actionToaster.msg}
        />
      )}

      <ModalPopup visible={saveDataModal.visible} width="485px">
        <div className="Popup-img">
          <img src={warning} alt="Warning" />
        </div>
        <div className="Popup-content">
          <span>Save Purchase Orders?</span>
          <p style={{ textAlign: "left" }}>
            {(() => {
              const canSavePOs = poData.current.data.pos.filter(
                (e) => e.error_count == 0 && !e.po.isErr && !e.isPOSaved
              );
              const canSaveCount = canSavePOs.length;
              const failedCount = poData.current.data.pos.filter(
                (e) => e.error_count > 0 || e.po.isErr
              ).length;
              const canSaveOrdersCount = canSavePOs.reduce(
                (sum, po) => sum + (po.orders?.length || 0),
                0
              );
              const canSaveLabel = canSaveCount === 1 ? "PO/SO" : "PO/SOs";
              const failedLabel = failedCount === 1 ? "PO" : "POs";
              const ordersLabel = canSaveOrdersCount === 1 ? "order" : "orders";
              const thereLabel = canSaveCount === 1 ? "is" : "are";
              return (
                <>
                  <div style={{ display: "flex", gap: "6px" }}>
                    <div>•</div>
                    <div>
                      <div>
                        There {thereLabel} {canSaveCount} unsaved {canSaveLabel} without any errors which can be saved.
                      </div>
                      <div>
                        {failedCount} {failedLabel} which failed validation cannot be saved.
                      </div>
                    </div>
                  </div>
                  {location.state?.checkBoxValue && (
                    <div style={{ display: "flex", gap: "6px", marginTop: "12px" }}>
                      <div>•</div>
                      <div>
                        <div>
                          Only the {canSaveCount} {canSaveLabel} and {canSaveOrdersCount} {ordersLabel} will be saved in the system.
                        </div>
                        <div>
                          REST ALL ORDERS WILL BE MARKED AS COMPLETED ONCE YOU SAVE.
                        </div>
                      </div>
                    </div>
                  )}
                </>
              );
            })()}
          </p>
        </div>
        <div className="ant-modal-footer-section">
          <Button
            key="back"
            className="themeBtn-plane"
            onClick={() => saveDataModalClose()}
          >
            <div className="plusPopUpBorder">
              <Iconmoon
                icon="plus-sign"
                size={9}
                color="#EA655B"
                className="ant-ico-sec"
              />
            </div>
            Cancel
          </Button>
          <Button
            key="submit"
            className="themeBtn"
            // disabled={((selectedPOs.data.pos.filter(e => ((e.error_count == 0 && !e.po.isErr) && !e.isPOSaved)).length) == 0)}
            disabled={
              poData.current.data.pos.filter(
                (e) => e.error_count == 0 && !e.po.isErr && !e.isPOSaved
              ).length == 0
            }
            onClick={() => saveDataModalConfirm(saveDataModal?.data)}
          >
            <Iconmoon icon="tick-mark" size={14} color="#ffff" />
            Confirm
          </Button>
        </div>
      </ModalPopup>
      {customerDrawerVisible && (
        <AddNewCustomerDrawer
          visible={customerDrawerVisible}
          onClose={onCloseCustomerDrawer}
          onCustSave={onCustomerSave}
          showToaster={showToaster}
          toasterAction={setActionToaster}
          customerName={selectedPo?.errors?.customer?.slice(selectedPo?.errors?.customer?.indexOf("'")+1,selectedPo?.errors?.customer?.lastIndexOf("'"))}
          role={"customer"}
        ></AddNewCustomerDrawer>
      )}
      {consigneeDrawerVisible && (
        <AddNewCustomerDrawer
          visible={consigneeDrawerVisible}
          onClose={onCloseConsigneeDrawer}
          onCustSave={onCustomerSave}
          showToaster={showToaster}
          toasterAction={setActionToaster}
          customerName={selectedPo?.errors?.consignee?.slice(selectedPo?.errors?.consignee?.indexOf("'")+1,selectedPo?.errors?.consignee?.lastIndexOf("'"))}
          role={"consignee"}
        ></AddNewCustomerDrawer>
      )}
    </RightLayoutContainer>
  );
};
export default UploadSummary;
